<template>
    <el-dialog
        :title="dialogTitle + ' 声光报警设置'"
        :model-value="modelValue"
        width="500px"
        @close="closed"
        align-center
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="formRules"
            label-width="120px"
            style="max-width: 560px"
        >
            <el-row>
                <el-col :span="24">
                    <el-form-item label="声光报警时长" prop="duration">
                        <div>
                            <el-input-number
                                style="width: 200px"
                                v-model="formData.duration"
                                placeholder="请输入告警时长"
                                :min="0"
                            ></el-input-number>
                            <span style="margin-left: 5px">单位：秒</span>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="播放告警声音" prop="code">
                        <el-radio
                            v-model="formData.sound"
                            v-for="item in isPlayAlarmSoundOptions"
                            :key="item.label"
                            :value="item.value"
                        >
                            {{ item.label }}
                        </el-radio>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="告警灯光颜色">
                        <el-checkbox
                            v-for="item in alarmSoundColor"
                            :key="item.value"
                            v-model="formData[item.value]"
                            @change="changeAlarmLightColor($event, item.value)"
                            :label="item.label"
                            :true-value="1"
                            :false-value="0"
                        />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { checkRemoveMsgMan, getAlarmLevelSettingDetail } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { ElMessage } from 'element-plus'
// import { validatePassword } from '@/utils/rules.js'
// import { Download, Plus, UploadFilled } from '@element-plus/icons'
// import { LOCALFS_ROOT } from '@/constant'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    alarmItem: {
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])

const isPlayAlarmSoundOptions = ref([
    { value: 1, label: '是' },
    { value: 0, label: '否' }
])

const alarmSoundColor = ref([
    { value: 'light_orange', label: '橘光' },
    { value: 'light_red', label: '红光' }
])

const changeAlarmLightColor = (value, label) => {
    if (value === true) {
        alarmSoundColor.value.forEach((item) => {
            formData.value[item.value] = false
        })
        formData.value[label] = true
    }
}

// 表单源
const formData = ref({
    duration: 1, // 声光报警时长（单位：秒），0:不限制；
    sound: 1, // 声音勾选，1:勾选，0:不勾选；
    light_orange: 0, // 橘光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
    light_red: 0 // 红光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
})
// 验证规则

const formRules = ref({
    // name: [
    //     {
    //         required: true,
    //         trigger: 'blur',
    //         message: '事件名称为必填项'
    //     }
    // ],
    // code: [
    //     {
    //         required: true,
    //         message: '事件编码为必填项',
    //         trigger: 'blur'
    //     }
    // ],
    // level: [
    //     {
    //         required: true,
    //         trigger: 'blur',
    //         message: '事件等级为必填'
    //     }
    // ]
})
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    console.log(formData.value)
    await doPutLevel()
}
// 提交data数据修饰
const getPostFormData = () => {
    const postFormData = {}
    postFormData.duration = formData.value.duration
    postFormData.sound = formData.value.sound
    postFormData.light_orange = formData.value.light_orange ? 1 : 0
    postFormData.light_red = formData.value.light_red ? 1 : 0
    return postFormData
}

// 修改
const doPutLevel = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        try {
            await checkRemoveMsgMan(props.alarmItem.id, { method: 'sound_light_setting', data: postFormData })
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

const loading = ref(false)
// 获取点位详情
const getEventDetail = async () => {
    loading.value = true
    const { sound_light_setting } = await getAlarmLevelSettingDetail(props.alarmItem.id)
    console.log(sound_light_setting, '---')
    if (sound_light_setting) {
        formData.value.duration = sound_light_setting.duration
        formData.value.sound = sound_light_setting.sound
        formData.value.light_orange = Boolean(sound_light_setting.light_orange)
        formData.value.light_red = Boolean(sound_light_setting.light_red)
    } else {
        formData.value.duration = 1 // 声光报警时长（单位：秒），0:不限制；
        formData.value.sound = 1 // 声音勾选，1:勾选，0:不勾选；
        formData.value.light_orange = false // 橘光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
        formData.value.light_red = false // 红光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
    }
    loading.value = false
}

onMounted(async () => {
    if (props.alarmItem) {
        dialogTitle.value = props.alarmItem.label
        getEventDetail()
    } else {
        formData.value = {
            duration: 1, // 声光报警时长（单位：秒），0:不限制；
            sound: 1, // 声音勾选，1:勾选，0:不勾选；
            light_orange: 0, // 橘光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
            light_red: 0 // 红光勾选，1:勾选，0:不勾选；【light_orange和light_red单选互斥】
        }
    }
})
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
body {
    margin: 0;
}
.example-showcase .el-loading-mask {
    z-index: 9;
}
</style>
